const check = (value: number): boolean => value >= 0 && value <= 255;

export const isCellValid = (value: string): boolean => /^\d{1,3}$/.test(value) && check(parseInt(value));
